export default function MealkitIcon() {
  return <i className="fa-solid fa-box"></i>
}